import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { homeApi } from "../../apis/home/homeApi";


export const fetchHomeDetails = createAsyncThunk(
    "fetchHomeDetails",
    async (productId) => {
        try {
            const response = await homeApi(productId);
            return response?.data?.data;
        } catch (error) {
            return null;
        }
    }
);

const homeSlice = createSlice({
    name: "propertyList",
    initialState: {
        isLoading: false,
        data: [],
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(fetchHomeDetails.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchHomeDetails.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        });

        builder.addCase(fetchHomeDetails.rejected, (state) => {
            state.isLoading = false;
            state.isError = true;
        });
    },
});

export default homeSlice.reducer;
